/**
* Tasks:
* 1. Use this list instead of audit-process.js (can be deleted)
* 2. Add support to sub,subtask,
*/

import store from "./store";

/** @return {{
  * category:string
  * id?:string
  * title:string
  * filterValue?:string
  * }[]
  * }[]}
 */
export default function createTaskList({ originalAST, simplifyAST, simplifierContent, files }) {
  let taskList = [];

  const checkForFunctions = () => {
    var type = "Functions"
    var nodeType = 'function'
    let nodes = simplifyAST.nodes.filter(x => x.kind == nodeType);
    if (nodes.length) {
      nodes.forEach((item) => {
        var list = [
          { id: 'functionNameDesc', title: "Does the function name clearly describe what it does?" },
          { id: 'functionNameTypos', title: 'There is no typos in the function name?.' },
          { id: 'functionModifierParams', title: "Is the function is using the correct modifiers with the correct params?" },
          { id: 'functionSignature', title: "If it's part of a standard, it the function signature defined correctly?" },
          { id: 'functionParamDesc', title: "Is the parameters clearly describe their meaning?" },
          { id: 'functionShouldWork', title: "Read the Solidity code and confirm that the function should work" },
          { id: 'functionNameCorrect', title: "Is the function name following naming best-practice? (camelCase)?" },
          { id: 'functionReversible', title: "Is it reversible?" },
          { id: 'functionRunAllowed', title: 'Confirm that only who allowed to run this function is able to call it' },
          { id: 'functionPass', title: 'Test the function against 3 values that should make this function to pass', usingSimulator: true },
          { id: 'functionFail', title: 'Test the function against 3 values that should make this function to fail', usingSimulator: true },
          { id: 'functionVarStorageName', title: 'Function variable is not shadowing storage with similar name', usingSimulator: true },
          { id: 'functionParamStorageName', title: 'Function param is not shadowing storage with similar name', usingSimulator: true },
        ]
        taskList.push(...list.map((x, index) => (
          {
            category: type,
            id: type + '.' + item.name + '.' + (x.id || x.title),
            title: (index + 1) + '. ' + x.title,
            filterValue: item.name,
            filterKey: undefined
          }
        )));
      });
    } else {
      return null;
    }
  };

  const checkForCompareOperatorsInFunctions = () => {
    let type = "Functions";

    const addToTaskList = (src, name) => {
      taskList.push(
        {
          category: type,
          id: type + '.' + name + '.compareOperator.'+(taskList.filter((item) => (item.filterValue == name)).length + 1),
          title: (taskList.filter((item) => (item.filterValue == name)).length + 1) +'. Confirm that the operator in the statement is correct.',
          filterValue: name,
          filterKey: undefined,
          goToSourceLocation: src
        }
      )
    }

    let nodeType = 'function';
    let nodes = simplifyAST.nodes.filter(x => x.kind == nodeType);
    console.log("nodes", nodes);
    if (nodes.length) {
      nodes.forEach((node) => {
        let nodeWithEqualOperator = store.deepSearchJSON(node, 'operator', '=');
        let nodeWithGreaterThanOperator = store.deepSearchJSON(node, 'operator', '>');
        let nodeWithLessThanOperator = store.deepSearchJSON(node, 'operator', '<');
        let nodeWithGreaterThanEqualOperator = store.deepSearchJSON(node, 'operator', '>=');
        let nodeWithLessThanEqualOperator = store.deepSearchJSON(node, 'operator', '<=');
        console.log("nodeWithEqualOperator", nodeWithEqualOperator);
        if (nodeWithEqualOperator.length) {
          nodeWithEqualOperator.forEach((item) => {
            addToTaskList(item.src, node.name);
          })
        }
        if (nodeWithGreaterThanOperator.length) {
          nodeWithGreaterThanOperator.forEach((item) => {
            addToTaskList(item.src, node.name);
          })
        }
        if (nodeWithLessThanOperator.length) {
          nodeWithLessThanOperator.forEach((item) => {
            addToTaskList(item.src, node.name);
          })
        }
        if (nodeWithGreaterThanEqualOperator.length) {
          nodeWithGreaterThanEqualOperator.forEach((item) => {
            addToTaskList(item.src, node.name);
          })
        }
        if (nodeWithLessThanEqualOperator.length) {
          nodeWithLessThanEqualOperator.forEach((item) => {
            addToTaskList(item.src, node.name);
          })
        }
      });
    } else {
      return null;
    }
  }

  const checkForStorage = () => {
    var type = "Storage"
    var nodeType = "VariableDeclaration"
    let nodes = simplifyAST.nodes.filter(x => x.nodeType == nodeType);
    if (nodes.length) {
      nodes.forEach((item) => {
        var list = [
          { id: 'storageNameTypos', title: 'There is no typos in the storage name?.' },
          { id: 'storageNameSimilar', title: 'There are no two storage with similar name?.' },
          { id: 'readOnlyReport', title: 'If it is read-only report it as something that cannot change' },
          { id: 'changeFuncChanging', title: 'Check that every function that should change it - is changing it' },
          { id: 'readFuncReading', title: 'Check that every function that should read it - is reading it' },
          { id: 'funcNotUsingStorage', title: 'Check that the storage is not used by function that does not need it' },
          { id: 'storageDescClear', title: 'Is the storage clearly describe what it does' },
          { id: 'changeStoragePermission', title: 'Check who have permission to change this storage' },
        ]
        taskList.push(...list.map((x, index) => (
          {
            category: type,
            id: type + '.' + item.name + '.' + (x.id || x.title),
            title: (index + 1) + '. ' + x.title,
            filterValue: item.name,
            filterKey: undefined
          }
        )))
      });
    } else {
      return null;
    }
  }
  const checkForModifiers = () => {
    var type = "Modifiers"
    var nodeType = "ModifierDefinition"
    let nodes = simplifyAST.nodes.filter(x => x.nodeType == nodeType);
    if (nodes.length) {
      nodes.forEach((item) => {
        var list = [
          { id: 'modifierDescClear', title: "Does the modifier name clearly describe what it does?" },
          { id: 'modifierCodeShort', title: "Is the modifier code short (usually 2 lines of code), and do you understand exactly what it does?", },
          { id: 'modifierAlterStorage', title: "Have you confirmed that the modifier does not alter the storage?", },
          { id: 'modifierCallExternalContract', title: "Have you confirmed that the modifier does not call to external smart contract?", },
          { id: 'modifierEmitsEvents', title: "Have you confirmed that the modifier does not emitting events?", },
          { id: 'modifierSimilarName', title: "Have you confirmed that there are not several modifiers with similar names?", },
          { id: 'modifierReadOneStorageVar', title: "Have you confirmed that the modifier does not read more than one storage variable? If there is an exception, ensure that it is documented in the specification.", },
          { id: 'modifierUserWhereNeeded', title: "Is the modifier used in every place where it is needed in the smart contract? Check all public functions." },
          { id: 'modifierNotUsedWhereNoNeed', title: "Have you confirmed that the modifier not appear in functions that are not in need of this modifier?" },
          { id: 'modifierContainsParams', title: "If the modifier contains params, is it used seem correctly?" },
          { id: 'modifierContainsCorrectParams', title: "If the modifier contains params, is the correct paramer passed to them?" },
        ]
        taskList.push(...list.map((x, index) => (
          {
            category: type,
            id: type + '.' + item.name + '.' + (x.id || x.title),
            title: (index + 1) + '. ' + x.title,
            filterValue: item.name,
            filterKey: undefined
          }
        )))
      });
    } else {
      return null;
    }
  }

  const checkForEvents = () => {
    var type = "Events"
    var nodeType = "EventDefinition"
    let nodes = simplifyAST.nodes.filter(x => x.nodeType == nodeType);
    if (nodes.length) {
      nodes.forEach((item) => {
        var list = [
          { id: 'eventNameDescOccured', title: "Does the event name clearly describe what just occurred?" },
          { id: 'eventNameTypos', title: 'There is no typos in the event name?.', },
          { id: 'eventParamDesc', title: "Does the name of each event parameter clearly describe its purpose?" },
          { id: 'eventPramsOrder', title: "Is every call to the event is using the correct parametrs in the correct order?" },
          { id: 'eventSignatureStandard', title: "If the event is a standard event (like ERC20, Transfer event), does the signature follow the standard?  (Make sure that the indexed parameters are also checked)." },
          { id: 'eventCustom', title: "If the event is a custom event, does the parameters are defined as \"indexed\" to the greatest extent possible?" },
          { id: 'eventTriggeredCorrect', title: "Is the event being triggered everywhere it should be?" },
          { id: 'eventMultiTriggered', title: "Is it sure that the same event is not triggered twice for the same data?" },
          { id: 'eventNameDesc', title: 'Check that event name clearly describe what it does', },
          { id: 'eventForModifiableStorage', title: 'Check that there is an event defiend for each modifiable storage' },
          { id: 'eventSimilarName', title: 'Check that there is no several events with similar names' }
        ]
        taskList.push(...list.map((x, index) => (
          {
            category: type,
            id: type + '.' + item.name + '.' + (x.id || x.title),
            title: (index + 1) + '. ' + x.title,
            filterValue: item.name,
            filterKey: undefined
          }
        )))
      });
    } else {
      return null;
    }
  }

  function addOthers() {
    var index = 1
    var type = 'WIP'
    var list = [
      { title: 'Check that there is no storage that is missing that should exists', },
      { title: 'ACL', },
      { title: 'Need a proxy', },
      { title: 'Do you think there is any modifier that is missing? It is necessary to have at least a modifier for each type of user (role and permission) who will be using the smart contract.', },
      { title: 'Ensure that an event is triggered every time writable storage variables are changed. This can be an existing event type, or a new event type should be added to the smart contract.', },
    ]
    taskList.push(...list.map((x) => (
      {
        category: type,
        id: type + '.' + (x.id || x.title),
        title: (index++) + '. ' + x.title,
      }
    )))

    var items = [{
      category: 'Sandwitch attack',
      forEach: "function",
      subtasks: [
        { id: 'functionManipulate', title: 'If this function manipulate the state ensure that it-safe to use the previous state just before ahead' },
        { id: 'approveOrIncrease', title: 'approve/increaseApproval' }
      ]
    },
    {
      category: 'Back-running',
      forEach: "function",
      subtasks: [
        { id: 'functionManipulate', title: 'If this function manipulate the state ensure that it-safe to use the previous state just before ahead' },
        { id: 'approveOrIncrease', title: 'approve/increaseApproval' }
      ]
    },
    {
      category: 'Front-running',
      forEach: "function",
      subtasks: [
        { id: 'functionManipulate', title: 'If this function manipulate the state ensure that it-safe to use the previous state just before ahead' },
        { id: 'approveOrIncrease', title: 'approve/increaseApproval' }
      ]
    },

    {
      category: 'Reentrancy',
      subtasks: [
        { id: 'stateCall', title: 'Check that state does not change before using address. call' },
        { id: 'stateSend', title: 'Check that state does not change before using address. send' },
        { id: 'stateTransfer', title: 'Check that state does not change before using address. transfer' },
      ]
    },
    {
      category: 'Compilation',
      subtasks: [
        { id: 'ensureLatest', title: 'Ensure the latest.' },
        { id: 'ensureOptimization', title: 'Ensure same optimization flags.' },
      ]
    },
    {
      category: 'Crisis Management',
      subtasks: [
        { id: 'pauseSmartContract', title: 'Is is possible to pause the smart contain using a master account?' },
      ]
    },
    {
      category: 'Code Quality',
      subtasks: [
        { id: 'notTooLongFunction', title: 'Is there are not too long functions?', usingSimplifier: 0 },
        { id: 'notTooNestedFunction', title: 'Is there are not too nested functions?', usingSimplifier: 0 },
      ]
    },
    {
      category: 'Documented',
      subtasks: [
        { id: 'codeDocumented', title: 'Is the document documented enough?', usingSimplifier: 0 },
      ]
    },
    {
      category: 'Safe destruct',
      subtasks: [
        { id: 'selfDesctuctFunction', title: 'Confirm that the smart contract does not contain self-descrtuct functions?' },
      ]
    },
    {
      category: 'unsafe tx.origin',
      subtasks: [
        { id: 'txOriginVarUse', title: 'Confirm that the smart contract does not use tx.origin variable' },
      ]
    },
    {
      category: 'Time manipulation',
      subtasks: [
        { id: 'controlOfMiner', title: 'Confirm that the control of the miner against block.number does not risk the smart contract', automated: 1 },
        { id: 'noBlockTimestampVar', title: 'Confirm that the smart contract does not use block.timestamp variable' },
      ]
    },
    {
      category: 'Bad randomness',
      subtasks: [
        { id: 'noRandom', title: 'Confirm that the smart contract does not use random that can be manipulated by miner' },
        { id: 'randomConfirm', title: 'If the smart contract needs random values confirm it\s randomness' },
      ]
    },
    {
      category: 'Attacks using smart-contract',
      subtasks: [
        { id: 'noBypass', title: 'Ensure that every requirement in the smart contract cannot bypassed if smart contract is calling it.' },
      ]
    },
    {
      category: 'Frozen value',
      subtasks: [
        { id: 'releaseTokens', title: 'Ensure the smart contract can release tokens sent to it.', usingSimulator: true, automated: 1 },
        { id: 'payableFunctions', title: 'If there area payable functions ensure smart contract can release Ether sent to it.', usingSimulator: true, automated: 1 },
        { id: 'receiveFunctions', title: 'If there area receive functions ensure smart contract can release Ether sent to it.', usingSimulator: true, automated: 1 },
      ]
    },
    {
      category: 'Denial of service',
      subtasks: [
        { id: 'whileLoopInfinite', title: 'Ensure there are not while-loop that goes into infinite value.', },
        { id: 'forLoopInfinite', title: 'Ensure the are not for-loop that goes into infinite value.' },
        { id: 'noExternalCallInsideLoop', title: 'Ensure there is not call to external smart contract inside for-loop.' },
        { id: 'noExternalSendInsideLoop', title: 'Ensure there is not send to external smart contract inside for-loop.' },
        { id: 'noExternalTransferInsideLoop', title: 'Ensure there is not transfer to external smart contract inside for-loop.' },
      ]
    },
    {
      category: 'Following specification',
      subtasks: [
        { id: 'noRequirement', title: 'Read the specification and ensure there is no requirement that not provided by the smart contract.', usingSimulator: true, },
      ]
    },
    {
      category: 'Following  standards',
      subtasks: [
        { id: 'erc20Standard', title: 'If it is an ERC20 token ensure it is matching the ERC20 standard.', },
        { id: 'erc721Standard', title: 'If it is an ERC721 token ensure it is matching the ERC20 standard.', },
        { id: 'erc1155Standard', title: 'If it is an ERC1155 token ensure it is matching the ERC20 standard.', },
      ]
    },
    {
      category: 'Price manipulation',
      subtasks: [
        { id: 'erc20Liquidity', title: 'If it is an ERC20 ensure users able to add it to the liqudity.', usingSimulator: true },
        { id: 'erc20Uniswap', title: 'If it is an ERC20 ensure users are able to switch it using UniSwap.', },
      ]
    },
    {
      category: 'UniSwap intergration',
      subtasks: [
        { id: 'erc20Liquidity', title: 'If it is an ERC20 ensure users able to add it to the liqudity.', usingSimulator: true },
        { id: 'erc20Uniswap', title: 'If it is an ERC20 ensure users are able to switch it using UniSwap.', },
      ]
    },
    {
      category: 'OpenSea intergration',
      subtasks: [
        { id: 'erc721Opensea', title: 'If it is an ERC721 users are able to sell and buy it on OpenSea.', usingSimulator: true },
      ]
    },
    {
      category: 'MakerDAO intergration',
      subtasks: [
        { id: 'erc20Colletorall', title: 'If it is an ERC20 users are able to put it as colletorall.', usingSimulator: true },
        { id: 'erc20Borrow', title: 'If it is an ERC20 users are able to borrow it.', usingSimulator: true },
      ]
    },
    {
      category: 'Conflict between fallback and receive functionality',
      subtasks: [
        { id: 'cannotHave', title: 'Cannot have...', usingSimulator: true },
      ]
    }]
    for (var a of items) {
      for (var x of a.subtasks) {
        taskList.push({
          category: type,
          id: type + '.' + (x.id || x.title),
          title: index++ + '. ' + a.category + x.title,
        })
      }
    }

    var list = [
      { title: 'Reply attacks' },
      { title: 'Upgradability' },
      { title: 'Grefing' },
      { title: 'Proxy-Upgradability' },
      { title: 'inline assembly' },
      { title: 'block hash' },
      { title: 'no return' },
      { title: 'Function with similars selector' },
      { title: 'Shadowing' },
      { title: 'result not used' },
      { title: 'delete in a dynamic array' },
      { title: 'If it is an upgrade ensure the storage layout does not change' },
      { title: 'Floating solidity version' },
      { title: 'Outdated Solidity' },
      { title: 'No hard coded ethereum addresses' },
      { title: 'Check wrong address' },
      { title: 'Things that related to ACL and proxy and transfer-proxy and storage-layouts' },
      { title: 'avoid using now (Efficiency)' },
      { title: 'Efficiency: pull over push (ether)' },
      { title: 'Efficiency: pull over push (tokens)' },
      { title: 'Functions with too many storage changes. (It what cost money)' },
      { title: 'Check all “require” statements in the smart contracts' },
      { title: 'Using address that does not exists (transfer to someone who not exists, or tokens to someone that not want to receive...)' },
    ]
    taskList.push(...list.map(x => (
      {
        category: type,
        id: type + '.' + (x.id || x.title),
        title: (index++) + '. ' + x.title,
      }
    )))
  }


  checkForFunctions();
  //checkForCompareOperatorsInFunctions();
  checkForStorage();
  checkForModifiers()
  checkForEvents()
  addOthers()



  // MODIFIERS





  let categories = _.uniq(_.map(taskList, 'category'));

  let taskObj = {
    tasks: taskList,
    categories: categories
  }

  // @ts-ignore
  return taskObj;
}